import { render, staticRenderFns } from "./ResendMail.vue?vue&type=template&id=1436c3dd"
import script from "./ResendMail.vue?vue&type=script&lang=js"
export * from "./ResendMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports